import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-delete-document-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './delete-document-modal.component.html',
  styleUrl: './delete-document-modal.component.css'
})
export class DeleteDocumentModalComponent {
  @Input() documentName!: string;
  @Output() deleteConfirmed = new EventEmitter<void>();

  constructor(public activeModal: NgbActiveModal) {}

  onCancel(): void { this.activeModal.dismiss(); }

  onDelete(): void { this.deleteConfirmed.emit(); }
}
